<template>
  <div id="customerData">
    <!-- Card header -->



    <!-- Card body -->
    <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
      <form class="needs-validation" @submit.prevent="handleSubmit(firstFormSubmit)">


        <b-row v-if="needsPastIns()">

          <b-col md="6">
            <h4>Versicherung des Fahrzeuges (Referenz)</h4>
            <base-input rules="required" name="Versicherung des Fahrzeuges (Referenz)">
              <el-select v-model="offer.insurance_id" filterable remote
                placeholder="Versicherung des Fahrzeuges (Referenz)" :remote-method="searchInsurances"
                :loading="loading">
                <el-option v-for="item in insurances" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </base-input>
          </b-col>


          <b-col md="6">
            <h4>Vertragsnummer</h4>
            <base-input prepend-icon="fas fa-user" placeholder="Vertragsnummer" v-model="offer.insurance_number"
              name="Vertragsnummer" :rules="{ required: true |{ regex: /[a-zA-Z0-9\s\d\w]*./ }}"></base-input>
          </b-col>

        </b-row>

      </form>
    </validation-observer>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { Select, Option } from "element-ui";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";


export default {
  name: "insurance",
  props: {
    title: "",
    icon: "",
  },
  components: {
    flatPicker,
    [Select.name]: Select,
    [Option.name]: Option,
    "v-select": vSelect,
  },
  data() {
    return {
      loading: false,
      insurances: [],
      req: ['V1', 'V2', 'U', 'Z', 'K', 'E', 'L', 'D', 'W', 'B', 'C', 'H', 'I', 'P', 'G1', 'G2', '1'],
    };
  },
  methods: {
    searchInsurances(query) {
      if (query !== "") {
        this.loading = true;
        this.$api
          .getInsurances(query)
          .then((response) => {
            console.log(response)
            this.insurances = [];
            this.insurances = response.data.items.map((item) => {
              return { value: item.id, label: item.vu_name };
            });
          })
          .catch((e) => {
            console.log(e);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    getInsurances() {
        this.loading = true;
        this.$api
          .getInsurances('*')
          .then((response) => {
            console.log(response);
            this.insurances = [];
            this.insurances = response.data.items.map((item) => {
              return { value: item.id, label: item.vu_name };
            });
           // this.getInsFromSelection(this.offer.insurance_id);
          })
          .catch((e) => {
            console.log(e);
          })
          .finally(() => {
            this.loading = false;
           // this.getInsFromSelection(this.offer.insurance_id);
           // console.log(this.getInsFromSelection(this.offer.insurance_id));
          });
    },
    getInsFromSelection(insurance_id) {
      console.log(insurance_id);
      console.log("filtering insid now");
      console.log(this.insurances);
      return this.insurances.filter((ins) => {
        console.log(ins);
        return ins.value().includes(insurance_id);
      });
    },
    getInsFromSelections(insurance_id) {
      this.offer.insurance_id = this.insurances.find(ins => ins.value === insurance_id).value;
      //this.offer.nationality_country = this.insurances.find(ins => ins.value === insurance_id).label;
    },
    needsPastIns(){
      if (this.req.includes(this.offer.leveling_type)){
        return true;
      }
      return false;
    },
    
  },
  computed: {
    ...mapGetters({ currentAccount: "currentAccount" }),
    ...mapState({
      offer: (state) => state.offer,
    }),
    insurance_id: (state) => state.offer.insurance_id,

  },
  watch: {
    insurance_id(newValue, oldValue) {
      console.log('queryParameter insurance_id changed -> running apply_rules:');
      this.getInsurances();
    },
  },
  mounted: function () {
    //this.getInsurances();
  },
};
</script>
<style>

</style>